module.exports = {"id":"192732","name":"Edgar Prib","rating":"72","photo":"./data/images/photos/0/192732.png","club":{"name":"Hanovre 96","logo":"./data/images/clubs/Hanovre96.png"},"positions":["MG","DG","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EdgarPrib0.json
// module id = 1172
// module chunks = 0